import { call, put, takeEvery, all, fork } from "redux-saga/effects";

import {
  SUPPLIER_PRODUCT_LIST,
  SUPPLIER_PRODUCT_DATA,
  SUPPLIER_PRODUCT_SEARCH,
  SUPPLIER_PRODUCT_CREATE,
  SUPPLIER_PRODUCT_UPDATE,
  SUPPLIER_PRODUCT_DELETE,
} from "./actionType";

import {
  supplierProductListSuccess,
  supplierProductListFailure,
  supplierProductDataSuccess,
  supplierProductDataFailure,
  supplierProductSearchSuccess,
  supplierProductSearchFailure,
  supplierProductCreateSuccess,
  supplierProductCreateFailure,
  supplierProductUpdateSuccess,
  supplierProductUpdateFailure,
  supplierProductDeleteSuccess,
  supplierProductDeleteFailure,
} from "./action";

import {
  getSupplierProductList,
  getSupplierProductData,
  getSupplierProductSearch,
  createSupplierProduct,
  updateSupplierProduct,
  deleteSupplierProduct,
} from "../../helpers/fakebackend_helper";

//SUPPLIER_PRODUCT_LIST
function* fetchSupplierProductList() {
  try {
    const response = yield call(getSupplierProductList);
    yield put(supplierProductListSuccess(response));
  } catch (error) {
    yield put(supplierProductListFailure(error));
  }
}
//watcher saga for SUPPLIER_PRODUCT_LIST
function* watchFetchSupplierProductList() {
  yield takeEvery(SUPPLIER_PRODUCT_LIST, fetchSupplierProductList);
}
//SUPPLIER_PRODUCT_DATA
function* fetchSupplierProductData(action) {
  try {
    const response = yield call(getSupplierProductData, action.payload);
    yield put(supplierProductDataSuccess(response));
  } catch (error) {
    yield put(supplierProductDataFailure(error));
  }
}
//watcher saga for SUPPLIER_PRODUCT_DATA
function* watchFetchSupplierProductData() {
  yield takeEvery(SUPPLIER_PRODUCT_DATA, fetchSupplierProductData);
}
//SUPPLIER_PRODUCT_SEARCH
function* fetchSupplierProductSearch(action) {
  try {
    const response = yield call(getSupplierProductSearch, action.payload);
    yield put(supplierProductSearchSuccess(response));
  } catch (error) {
    yield put(supplierProductSearchFailure(error));
  }
}
//watcher saga for SUPPLIER_PRODUCT_SEARCH
function* watchFetchSupplierProductSearch() {
  yield takeEvery(SUPPLIER_PRODUCT_SEARCH, fetchSupplierProductSearch);
}
//SUPPLIER_PRODUCT_CREATE
function* createSupplierProductSaga(action) {
  try {
    const response = yield call(createSupplierProduct, action.payload);
    yield put(supplierProductCreateSuccess(response));
  } catch (error) {
    yield put(supplierProductCreateFailure(error));
  }
}
//watcher saga for SUPPLIER_PRODUCT_CREATE
function* watchCreateSupplierProduct() {
  yield takeEvery(SUPPLIER_PRODUCT_CREATE, createSupplierProductSaga);
}
//SUPPLIER_PRODUCT_UPDATE
function* updateSupplierProductSaga(action) {
  try {
    const response = yield call(updateSupplierProduct, action.payload);
    yield put(supplierProductUpdateSuccess(response));
  } catch (error) {
    yield put(supplierProductUpdateFailure(error));
  }
}
//watcher saga for SUPPLIER_PRODUCT_UPDATE
function* watchUpdateSupplierProduct() {
  yield takeEvery(SUPPLIER_PRODUCT_UPDATE, updateSupplierProductSaga);
}
//SUPPLIER_PRODUCT_DELETE
function* deleteSupplierProductSaga(action) {
  try {
    const response = yield call(deleteSupplierProduct, action.payload);
    yield put(supplierProductDeleteSuccess(response));
  } catch (error) {
    yield put(supplierProductDeleteFailure(error));
  }
}
//watcher saga for SUPPLIER_PRODUCT_DELETE
function* watchDeleteSupplierProduct() {
  yield takeEvery(SUPPLIER_PRODUCT_DELETE, deleteSupplierProductSaga);
}
// Root saga to combine all watcher sagas
export default function* supplierProductSaga() {
  yield all([
    fork(watchFetchSupplierProductList),
    fork(watchFetchSupplierProductData),
    fork(watchFetchSupplierProductSearch),
    fork(watchCreateSupplierProduct),
    fork(watchUpdateSupplierProduct),
    fork(watchDeleteSupplierProduct),
  ]);
}
